import HttpRequest from './http_request'

class ApplicantInfoProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT)
  }

  async getRegisConstraints() {
    const { data } = await this.get('admission/api/', {
      function: 'get-user-constraint',
    })
    return data
  }

  async setRegisConstraints(user_constraint_list) {
    const { data } = await this.update('admission/api/', {
      function: 'set-user-constraint',
      user_constraint_list
    })
    return data
  }

  async getRegisProject() {
    const { data } = await this.get('admission/api/', {
      function: 'get-register-list',
    })
    return data
  }

  async regisCurriculum(project_id, curriculum_ids) {
    const { data } = await this.create('admission/api/', {
      function: 'regis-curriculum',
      PROJECT_ID: project_id,
      register_curriculum: curriculum_ids,
    })
    return data
  }

  async cancelRegis(REGISTER_ID, REFUSE_REMARK) {
    const { data } = await this.delete('admission/api/', {
      function: 'refuse-registered-curriculum',
      REGISTER_ID,
      REFUSE: 3,
      REFUSE_REMARK,
    })
    return data;
  }

  async setApplicantInfoGeneral(info) {
    const { data } = await this.update('admission/api/', {
      function: 'set-user-info',
      CITIZEN_ID: info.CITIZEN_ID,
      CREATE_USER_ACCOUNT_AS_INTER: (info.CREATE_USER_ACCOUNT_AS_INTER) ? 1 : 0,
      EMAIL: info.EMAIL,
      GENDER_ID: info.GENDER_ID,
      MOBILE: info.MOBILE,
      NATION_ID: info.NATION_ID,
      PREFIX_NAME_ID: info.PREFIX_NAME_ID,
      STUDENT_FNAME_EN: info.STUDENT_FNAME_EN,
      STUDENT_FNAME_TH: info.STUDENT_FNAME_TH,
      STUDENT_LNAME_EN: info.STUDENT_LNAME_EN,
      STUDENT_LNAME_TH: info.STUDENT_LNAME_TH,
      BIRTHDAY: info.BIRTHDAY,
    })
    return data
  }

  async getApplicantInfoSchool(uid=null) {
    const { data } = await this.get('admission/api/', {
      function: 'get-educational-background-ungrad',
      UID:uid,
    })
    return data
  }

  async setApplicantInfoSchool(info) {
    const { data } = await this.update('admission/api/', {
      function: 'set-educational-background-ungrad',

      COUNTRY_ID_OF_SCHOOL: info.COUNTRY_ID_OF_SCHOOL,
      SCHOOL_NAME: info.SCHOOL_NAME,
      SCHOOL_ID: info.SCHOOL_ID,
      SCHOOL_TYPE_ID: info.SCHOOL_TYPE_ID,
      EDUCATION_TYPE_ID: info.EDUCATION_TYPE_ID,
      EDUCATION_OTHER: info.EDUCATION_OTHER,
      STUDY_STATUS_ID: info.STUDY_STATUS_ID,
      STUDY_TYPE_ID: info.STUDY_TYPE_ID,
      TERM_OF_GPA: info.TERM_OF_GPA,
      GPA: info.GPA,
    })
    return data
  }

  async getApplicantInfoUniversity(uid=null) {
    const { data } = await this.get('admission/api/', {
      function: 'get-educational-background-grad',
      UID:uid,
    })
    return data
  }

  async setApplicantInfoUniversity(info) {
    const { data } = await this.update('admission/api/', {
      function: 'set-educational-background-grad',
      COUNTRY_ID_OF_UNIVERSITY: info.COUNTRY_ID_OF_UNIVERSITY,
      UNIVERSITY_NAME: info.UNIVERSITY_NAME,
      UNIVERSITY_ID: info.UNIVERSITY_ID,
      GRADUATED_YEAR: info.GRADUATED_YEAR,
      UNIVERSITY_STUDY_STATUS: info.UNIVERSITY_STUDY_STATUS,
      DEGREE_NAME: info.DEGREE_NAME,
      CURRICULUM_NAME: info.CURRICULUM_NAME,
      GPA: info.GPA,
      MASTER_COUNTRY_ID_OF_UNIVERSITY: info.MASTER_COUNTRY_ID_OF_UNIVERSITY,
      MASTER_UNIVERSITY_NAME: info.MASTER_UNIVERSITY_NAME,
      MASTER_UNIVERSITY_ID: info.MASTER_UNIVERSITY_ID,
      MASTER_GRADUATED_YEAR: info.MASTER_GRADUATED_YEAR,
      MASTER_UNIVERSITY_STUDY_STATUS: info.MASTER_UNIVERSITY_STUDY_STATUS,
      MASTER_DEGREE_NAME: info.MASTER_DEGREE_NAME,
      MASTER_CURRICULUM_NAME: info.MASTER_CURRICULUM_NAME,
      MASTER_GPA: info.MASTER_GPA,
      NUM_OF_YEAR_WORKING: info.NUM_OF_YEAR_WORKING,
      COMPANY_NAME: info.COMPANY_NAME,
      SINCE_WORKING: info.SINCE_WORKING,
      POSITION_IN_COMPANY: info.POSITION_IN_COMPANY,
      COMPANY_NAME_1: info.COMPANY_NAME_1,
      SINCE_WORKING_1: info.SINCE_WORKING_1,
      POSITION_IN_COMPANY_1: info.POSITION_IN_COMPANY_1,
    })
    return data
  }

  async getApplicantInfoMedical() {
    const { data } = await this.get('admission/api/', {
      function: 'get-educational-background-medicine',
    })
    return data
  }

  async setApplicantInfoMedical(info) {
    const { data } = await this.update('admission/api/', {
      function: 'set-educational-background-medicine',

      DIPLOMA_TYPE: info.DIPLOMA_TYPE,

      SAT_2_BIO_SCORE: info.SAT_2_BIO_SCORE,
      SAT_2_CHEM_SCORE: info.SAT_2_CHEM_SCORE,
      SAT_2_PHY_SCORE: info.SAT_2_PHY_SCORE,
      SAT_2_MATH_SCORE: info.SAT_2_MATH_SCORE,
      SAT_2_TEST_DATE: info.SAT_2_TEST_DATE,

      BMAT_SECTION_1_SCORE: info.BMAT_SECTION_1_SCORE,
      BMAT_SECTION_2_SCORE: info.BMAT_SECTION_2_SCORE,
      BMAT_SECTION_3_SCORE: info.BMAT_SECTION_3_SCORE,
      BMAT_TEST_DATE: info.BMAT_TEST_DATE,

      SPOT_SCORE: info.SPOT_SCORE,
      SPOT_TEST_DATE: info.SPOT_TEST_DATE,

      TOEFL_IBT_SCORE: info.TOEFL_IBT_SCORE,
      TOEFL_PBT_SCORE: info.TOEFL_PBT_SCORE,
      TOEFL_CBT_SCORE: info.TOEFL_CBT_SCORE,
      TOFEL_TEST_DATE: info.TOFEL_TEST_DATE,
      IELTS_SCORE: info.IELTS_SCORE,
      IELTS_TEST_DATE: info.IELTS_TEST_DATE,
      CU_TEP_SCORE: info.CU_TEP_SCORE,
      CU_TEP_TEST_DATE: info.CU_TEP_TEST_DATE,
      PERSONAL_STATEMENT: info.PERSONAL_STATEMENT,
    })
    return data
  }

  async getApplicantInfoEngInter() {
    const { data } = await this.get('admission/api/', {
      function: 'get-educational-background-inter',
    })
    return data
  }

  async setApplicantInfoEngInter(info) {
    const { data } = await this.update('admission/api/', {
      function: 'set-educational-background-inter',
      DIPLOMA_TYPE: info.DIPLOMA_TYPE,
      SUBJECT_1_NAME: info.SUBJECT_1_NAME,
      SUBJECT_1_SCORE: info.SUBJECT_1_SCORE,
      SUBJECT_1_TEST_DATE: info.SUBJECT_1_TEST_DATE,
      SUBJECT_2_NAME: info.SUBJECT_2_NAME,
      SUBJECT_2_SCORE: info.SUBJECT_2_SCORE,
      SUBJECT_2_TEST_DATE: info.SUBJECT_2_TEST_DATE,
      SUBJECT_3_NAME: info.SUBJECT_3_NAME,
      SUBJECT_3_SCORE: info.SUBJECT_3_SCORE,
      SUBJECT_3_TEST_DATE: info.SUBJECT_3_TEST_DATE,

      GED_RTLA_SCORE: info.GED_RTLA_SCORE,
      GED_MR_SCORE: info.GED_MR_SCORE,
      GED_SCI_SCORE: info.GED_SCI_SCORE,
      GED_SS_SCORE: info.GED_SS_SCORE,
      GED_TEST_DATE: info.GED_TEST_DATE,

      SAT_1_MATH_SCORE: info.SAT_1_MATH_SCORE,
      SAT_1_RW_SCORE: info.SAT_1_RW_SCORE,
      SAT_1_TOTAL_SCORE: info.SAT_1_TOTAL_SCORE,
      SAT_1_TEST_DATE: info.SAT_1_TEST_DATE,
      OLD_SAT_VERBAL_SCORE: info.OLD_SAT_VERBAL_SCORE,
      OLD_SAT_MATH_SCORE: info.OLD_SAT_MATH_SCORE,
      OLD_SAT_WRITING_SCORE: info.OLD_SAT_WRITING_SCORE,
      OLD_SAT_TEST_DATE: info.OLD_SAT_TEST_DATE,

      SAT_2_BIO_SCORE: info.SAT_2_BIO_SCORE,
      SAT_2_CHEM_SCORE: info.SAT_2_CHEM_SCORE,
      SAT_2_PHY_SCORE: info.SAT_2_PHY_SCORE,
      SAT_2_MATH_SCORE: info.SAT_2_MATH_SCORE,
      SAT_2_TEST_DATE: info.SAT_2_TEST_DATE,

      ACT_SCORE: info.ACT_SCORE,
      ACT_TEST_DATE: info.ACT_TEST_DATE,
      IB_SCORE: info.IB_SCORE,
      IB_TEST_DATE: info.IB_TEST_DATE,

      GAT_1_SCORE: info.GAT_1_SCORE,
      GAT_2_SCORE: info.GAT_2_SCORE,
      GAT_TEST_DATE: info.GAT_TEST_DATE,
      PAT_1_SCORE: info.PAT_1_SCORE,
      PAT_3_SCORE: info.PAT_3_SCORE,
      PAT_TEST_DATE: info.PAT_TEST_DATE,

      TOFEL_SCORE: info.TOFEL_SCORE,
      TOFEL_TEST_DATE: info.TOFEL_TEST_DATE,
      IELTS_SCORE: info.IELTS_SCORE,
      IELTS_TEST_DATE: info.IELTS_TEST_DATE,
      KMITL_TEP_SCORE: info.KMITL_TEP_SCORE,
      KMITL_TEP_TEST_DATE: info.KMITL_TEP_TEST_DATE,
      OTHER_NAME: info.OTHER_NAME,
      OTHER_SCORE: info.OTHER_SCORE,
      OTHER_TEST_DATE: info.OTHER_TEST_DATE,

    })
    return data
  }

  async uploadRegisterFile({ FILE, REGISTER_ID }) {
    let formData = new FormData();
    formData.append('FILE[0]', FILE);
    formData.append('function', 'upload-document-file');
    formData.append('service_type', 'register');
    formData.append('REGISTER_ID', REGISTER_ID);
    const { data } = await this.create('admission/api/', formData)
    return data
  }

  async deleteRegisterFile({ REGISTER_ID }) {
    const { data } = await this.delete('admission/api/', {
      function: 'delete-document-file',
      service_type: 'register',
      REGISTER_ID: REGISTER_ID,
    })
    return data
  }

  async getApplicantInfoAdditionalUndergraduate(uid=null) {
    const { data } = await this.get('admission/api/', {
      function: 'get-user-detail',
      UID:uid,
    })
    return data
  }

  async setApplicantInfoAdditionalUndergraduate(info) {
    const { data } = await this.update('admission/api/', {
      function: 'set-user-detail',

      ADDRESS: info.ADDRESS,

      USER_DETAIL_1: info.USER_DETAIL_1,
      USER_DETAIL_2: info.USER_DETAIL_2,
      USER_DETAIL_3: info.USER_DETAIL_3,
      USER_DETAIL_4: info.USER_DETAIL_4,
      USER_DETAIL_5: info.USER_DETAIL_5,
      USER_DETAIL_6: info.USER_DETAIL_6,
      USER_DETAIL_7: info.USER_DETAIL_7,
    })
    return data
  }
}

export default ApplicantInfoProvider